import type { StatusTagStatus } from "@kanda-libs/ks-design-library";

export const STATUS_TAG_PROPS = {
  className: "mr-3",
  status: "draft" as StatusTagStatus,
};
